import './ParentInvolvement.css';

import parentImage from "../assets/parent4.webp";
import boardImage from "../assets/teamwork.webp";

const ParentInvolvement = () => {
//   const volunteerSections = [
//     {
//       icon: <FaHandsHelping aria-label="Big Roles icon" />,
//       title: "Big Roles",
//       description:
//         "Many Binkley parents take on large roles, such as serving on the Parent Board or chairing fundraisers.",
//       bgColor: "#FFD6D6",
//     },
//     {
//       icon: <FaBookOpen aria-label="Class Helpers icon" />,
//       title: "Class Helpers",
//       description:
//         "Parents help as guest readers or helpers during class parties, supporting our teachers and students.",
//       bgColor: "#D6F0FF",
//     },
//     {
//       icon: <FaRegSmile aria-label="Celebration Fun icon" />,
//       title: "Celebration Fun",
//       description:
//         "They make play dough, clap and cheer during our Halloween parades, and join in special activities.",
//       bgColor: "#FFF3D6",
//     },
//     {
//       icon: <FaUserFriends aria-label="Everyday Support icon" />,
//       title: "Everyday Support",
//       description:
//         "Parents are important partners with our teachers in their child’s first school experiences.",
//       bgColor: "#D6FFD6",
//     },
//   ];

  return (
    <div className="parent-involvement">
      {/* Header */}
      <section className="parent-involvement-header"> 
        <h1>Parent Involvement at Binkley Preschool</h1>
      </section>

      {/* Parent Involvement Content */}
      <section className="parent-involvement-content">
        <img 
          src={parentImage} 
          alt="Parents interacting with children at Binkley Preschool" 
          className="parent-involvement-image" 
        />
        <p>
          <span>Here at Binkley, parents are always welcome!</span> <br/><br/>
          While there is no required time commitment, volunteer efforts by our families help our preschool in many, many ways! Many Binkley parents take on large roles, such as serving on the Parent Board or chairing fundraisers.
          <br/><br/>
          Parents also help us with smaller but equally important tasks, such as being a guest reader or helper during a class party. They make play dough, clap and cheer during our Halloween parades, and are important partners with our teachers in their child’s first school experiences.
          <br/><br/>
          We place great importance on the home-school connection. We keep our families informed via the Brightwheel platform with weekly “Friday Family Notes”, activity-specific emails, and newsletters.
        </p>
      </section>

      {/* Fun Tasks Section */}
      <section className="parent-involvement-fun-tasks">
        <h2>Fun Ways Parents Help:</h2>
        <div className="fun-tasks-cards">
          <div className="fun-task-card">Guest Reader</div>
          <div className="fun-task-card">Class Party Helper</div>
          <div className="fun-task-card">Make some Play Dough</div>
          <div className="fun-task-card">Cheer at the annual Halloween Parade</div>
          <div className="fun-task-card">Partner with Teachers</div>
        </div>
      </section>

      {/* Parent Board Section */}
      <section className="parent-board-content">
        <p>
          <span>Join Binkley's Volunteer Parent Board</span>
          <br/><br/>
          The Binkley Preschool Parent Board is made up of dedicated parents who help keep the heart of our school running smoothly. They manage essential areas such as finances, staffing, registration, parent relations, scholarships, major equipment acquisition and repair, and record keeping—basically, the behind-the-scenes work that keeps Binkley thriving! To keep our community informed, minutes from Parent Board meetings are shared each month.
          <br/><br/>
          We value parent involvement and input. Each spring, any interested parent is welcome to apply for a Board position. A selection committee carefully reviews applications and presents the nominations to the current Board.
        </p>

        <img 
          src={boardImage} 
          alt="Binkley Parent Board working together" 
          className="parent-board-image" 
        />
      </section>
    </div>
  );
};

export default ParentInvolvement;
